<template>
    <div class="x-tablelist-view" data-automation="manageProduct">
      <!-- 搜索行 -->
      <div class="search-warp">
        <el-row type="flex" justify="start" :gutter="16">
          <el-col :span="4">
            <ux-select style="width: 180px;" v-model="filter.productId" clearable :options="productList" :props="{label:'name',value:'id'}" :placeholder="$t('HT.label.allProductService')"></ux-select>
          </el-col>
            <el-col :span="8">
                <add-imei-input
                    v-model="filter.deviceImei"
                    :showAdd="false"
                ></add-imei-input>
            </el-col>
            <el-col :span="8">
              <ux-date v-model="filter.date" daterange time ></ux-date>
            </el-col>

             <el-col >
                <el-button type="primary"  @click="seach"  size="small">{{
                    $t('HT.search')
                }}</el-button>
                <el-button plain @click="reset" size="small" >{{
                    $t('HT.reset')
                }}</el-button>
                <el-button type="primary" @click="handleExport"  size="small" style="float: right;">{{
                    $t('HT.orderOverview.export')
                }}</el-button>
            </el-col>
        </el-row>
      </div>

      <!-- 表格 -->
      <div class="x-table-box">
        <ux-table
          ref="table"
          :showPage="showPage"
          maxHeight="100%"
          :hide-on-single-page="true"
          :data="tableData.list"
          :columns="columns1"
          :background="false"
          :total="tableData.totalSize"
          :size.sync="filter.size"
          :page.sync="filter.page"
          @changePage="changePage"
          @changeSize="changeSize"
          :emptyText="$t('HT.nodata')"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>
  </template>

  <script>
    import AddImeiInput from '@/components/AddImeiInput/index.vue';
export default {
  components: {
        AddImeiInput
  },
  data() {
        return {
          userData: {}, // 登录者信息
          word: this.$t('HT.options.productStatus2'),
          showPage: true,
          isShow: true,
          productList:[],
          columns1: [
          // 表头数据
            {
              label: this.$t('HT.applyInfo.createTime'),
              prop: 'invoke_time',
              align: 'left',
              tooltip: true,
            },
            {
              label: this.$t('HT.label.imei'),
              tooltip: true,
              align: 'left',
              prop:'device_imei'
            },
            {
              label: this.$t('HT.unbindApi.name'),
              prop: 'product_name',
              align: 'left',
              tooltip: true
            },
            {
              label: this.$t('HT.label.apiName'),
              prop: 'api_name',
              align: 'left',
              tooltip: true
            },
            {
              label: this.$t('HT.label.locationType'),
              prop: 'location_type',
              align: 'left',
              tooltip: true,
              formatter: (row, column, cellValue) => {
                return cellValue || '--';
              }
            },
            {
              label: this.$t('HT.label.locationInfo'),
              prop: 'location_information',
              align: 'left',
              tooltip: true,
              formatter: (row, column, cellValue) => {
                return cellValue || '--';
              }
            },
            {
              label: this.$t('HT.label.latlng'),
              prop: 'lat_lng',
              tooltip: true,
              align: 'left',
              minWidth:'120px',
              formatter: (row, column, cellValue) => {
                return cellValue || '--';
              }
            }
          ],
          filter: {
          // 查询参数
            productId: '',
            deviceImei: '',
            date:[],
            page: 1,
            size: 10
          },
          tableData: {
          // 表格数据
            totalSize: 0,
            list: []
          }
        };
  },
  mounted() {
        const {deviceImei,startTime,endTime}=this.$route.query||{};
        if(startTime){
          this.filter.date=[startTime,endTime];
          this.filter.deviceImei=deviceImei;
        }
        this.getAllList();
        this.getSupervisor();
        this.userData = this.$store.state.login.userData;
        this.getAllProduct();
  },
  methods: {
      /**
       * 获取超级管理员字段
       * @param {String}
       */
        getSupervisor() {
          this.isShow = JSON.parse(localStorage.getItem('userData')).supervisor;
        },

        async getAllProduct(){
        // 后端没有提供接口，直接用的产品列表接口
          let {data}=await this.$api.product.getAllProduct();
          this.productList=data;
        },
        /**
       * 获取列表
       * @param {Object} params 请求参数
       */
        getAllList() {
          const [startTime,endTime]=this.filter.date;
          const params=Object.assign({startTime,endTime},this.filter);
          params.deviceImei = params.deviceImei.replace(/[(\r\n)\r\n]+/g, ',');
          delete params.date;
          this.$uxLoading.show();
          this.$api.device.getLog(params).then((res) => {
            if (res.code == 10000) {
              this.tableData = {
                totalSize: res.total_size,
                list: res.data
              };
            }
          });
        },


        /**
       * 搜索
       */
        seach() {
          this.filter.page = 1;
          this.getAllList();
        },

        /**
       * 改变页容量
       * @param {Number} size 选择的页容量
       */
        changeSize(size) {
          this.filter.size = size;
          this.filter.page = 1;
          this.getAllList();
        },
        /**
       * 改变页码
       * @param {Number} page 选择的页码
       */
        changePage(page) {
          this.filter.page = page;
          this.getAllList();
        },

        // 下载文件
        downloadFile(res) {
          let fileName = '';
          if (res.headers['content-disposition'].split('=')[1]) {
            fileName = decodeURIComponent(res.headers['content-disposition'].split('=')[1]);
          }
          const url = window.URL.createObjectURL(res.data);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        },
        // 导出
        handleExport() {
          const config = {
            responseType: 'blob',
            config: true
          };
          const params = this.filter;
          this.$uxLoading.show();
          this.$api.device.exportReport(params, config)
            .then((res) => {
              this.downloadFile(res);
            })
            .catch(() => {
              this.$uxMessage.error(this.$t('HT.orderOverview.exportError'));
            });
        },
        reset(){
          this.filter.deviceImei='';
          this.filter.date=[];
          this.filter.page=1;
          this.filter.size=10;
          this.getAllList();
        }

  }
};
  </script>
